import { File, FileArchive, FileSpreadsheet, FileText } from 'lucide-react'
import type { ComponentType } from 'react'

export function isImage(contentType: string): boolean {
  return contentType.startsWith('image/')
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
  return `${(n / (1024 * 1024)).toFixed(1)} MB`
}

export type FileKind = 'pdf' | 'sheet' | 'archive' | 'file'

export function fileKind(contentType: string): FileKind {
  if (contentType === 'application/pdf') return 'pdf'
  if (contentType.includes('spreadsheet') || contentType.includes('ms-excel') || contentType === 'text/csv')
    return 'sheet'
  if (contentType === 'application/zip') return 'archive'
  return 'file'
}

const ICONS: Record<FileKind, ComponentType<{ className?: string }>> = {
  pdf: FileText,
  sheet: FileSpreadsheet,
  archive: FileArchive,
  file: File,
}

export function fileIcon(contentType: string): ComponentType<{ className?: string }> {
  return ICONS[fileKind(contentType)]
}
